// @ts-strict-ignore
import React from "react";
import styled from "styled-components";

const UnderlineParent = styled.span`
  position: relative;
  ${(props) =>
    props.active &&
    `
      color: #b3b3b4;
    `};
`;

const AnimatedUnderline = styled.span`
  font-size: ${({ customFontSize }) =>
    customFontSize ? customFontSize : "14px"};
  line-height: ${({ customLineHeight }) =>
    customLineHeight ? customLineHeight : "28px"};
  &:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -5px;
    width: 0px;
    height: 2px;
    margin: 5px 0 0;
    transition: all 0.2s ease-in-out;
    opacity: 0;
    ${(props) =>
      props.active &&
      `
      width: 100%;
      opacity: 1;
    `};
  }
  &:hover,
  &:focus {
    cursor: pointer;
    &:before,
    &:after {
      width: 100%;
      opacity: 1;
    }
  }
`;

interface HoverUnderlineProps {
  children: any;
  active?: boolean;
  underlineColor?: string;
  customFontSize?: string;
  customLineHeight?: string;
}

const HoverUnderline: React.FunctionComponent<HoverUnderlineProps> = ({
  children,
  active = false,
  underlineColor,
  customFontSize,
  customLineHeight
}) => (
  <UnderlineParent active={active}>
    <AnimatedUnderline
      underlineColor={underlineColor}
      active={active}
      customFontSize={customFontSize}
      customLineHeight={customLineHeight}
    >
      {children}
    </AnimatedUnderline>
  </UnderlineParent>
);

export default HoverUnderline;
